export const CREATE_FORMLAYOUT_JSON = "CREATE_FORMLAYOUT_JSON";
export const CREATE_FORMLAYOUT_JSON_SUCCESS = "CREATE_FORMLAYOUT_JSON_SUCCESS";
export const CREATE_FORMLAYOUT_JSON_FAILURE = "CREATE_FORMLAYOUT_JSON_FAILURE";

export const REFRESH_REDIS_CACHE = "REFRESH_REDIS_CACHE";
export const REFRESH_REDIS_CACHE_SUCCESS = "REFRESH_REDIS_CACHE_SUCCESS";
export const REFRESH_REDIS_CACHE_FAILURE = "REFRESH_REDIS_CACHE_FAILURE";

export const REFRESH_ACTION_SCOPES = "REFRESH_ACTION_SCOPES";
export const REFRESH_ACTION_SCOPES_SUCCESS = "REFRESH_ACTION_SCOPES_SUCCESS";
export const REFRESH_ACTION_SCOPES_FAILURE = "REFRESH_ACTION_SCOPES_FAILURE";

export const RESET_WARRANTIES_REPORT = "RESET_WARRANTIES_REPORT";

export const REFRESH_PROPERTY_MANAGER_JSON = "REFRESH_PROPERTY_MANAGER_JSON";
export const REFRESH_PROPERTY_MANAGER_JSON_SUCCESS = "REFRESH_PROPERTY_MANAGER_JSON_SUCCESS";
export const REFRESH_PROPERTY_MANAGER_JSON_FAILURE = "REFRESH_PROPERTY_MANAGER_JSON_FAILURE";

export const API_DEEP_HEALTH_CHECK = "API_DEEP_HEALTH_CHECK";
export const API_DEEP_HEALTH_CHECK_SUCCESS = "API_DEEP_HEALTH_CHECK_SUCCESS";
export const API_DEEP_HEALTH_CHECK_FAILURE = "API_DEEP_HEALTH_CHECK_FAILURE";
